{
  "Earlier": "FRÜHER",
  "noAnnouncements": "Sie erhalten Informationen zu geplanten Wartungsarbeiten und Produktfehlern, die behoben wurden.",
  "noAnnouncementsTitle": "Ihre Ankündigungen werden hier angezeigt"
}
